<!-- NewImprintModule.vue - Wrapper for each imprint with header and collapsible content -->
<template>
  <div class="new-imprint-module">
    <!-- Header -->
    <div class="imprint-header">
      <div class="header-content">
        <h3 class="imprint-title c-f-white">{{ title }}</h3>
        <button 
          v-if="collapsible"
          class="collapse-btn"
          :class="{ 'collapsed': isCollapsed }"
          @click="toggleCollapse"
          aria-label="Toggle imprint details"
        >
          <span class="collapse-icon">{{ isCollapsed ? '+' : '−' }}</span>
        </button>
      </div>
    </div>

    <!-- Container (collapsible content) -->
    <div 
      v-show="!isCollapsed"
      class="imprint-container"
    >
      <slot></slot>
      
      <!-- Delete Imprint Button (only if deletable) -->
      <div v-if="deletable" class="delete-section">
        <button 
          class="delete-btn"
          @click="handleDelete"
        >
          Delete Imprint
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewImprintModule',

  props: {
    // Title shown in header
    title: {
      type: String,
      default: 'First Imprint'
    },
    
    // Whether module can be collapsed
    collapsible: {
      type: Boolean,
      default: true
    },
    
    // Initial collapsed state
    initialCollapsed: {
      type: Boolean,
      default: false
    },
    
    // Whether delete button is shown
    deletable: {
      type: Boolean,
      default: false
    },
    
    // Imprint index/key
    imprintKey: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      isCollapsed: this.initialCollapsed
    };
  },

  methods: {
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
      this.$emit('collapse-toggled', this.isCollapsed);
    },
    
    handleDelete() {
      this.$emit('delete-requested', this.imprintKey);
    }
  }
};
</script>

<style scoped lang="scss">
@use '@/styles/utils' as *;
.new-imprint-module {
  width: 100%;
  background: #FFFFFF;
  border: 1px solid #D9D9D9;
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 20px;
  
  &:last-child {
    margin-bottom: 0;
  }
}

// Header
.imprint-header {
  width: 100%;
  background: $brand-primary;
  padding: 15px 10px;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.imprint-title {
  flex: 1;
  margin: 0;
  text-align: center;
  font-family: $font-family-base;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
    &.c-f-white {
        color: #FFFFFF !important;
        text-align: left;
        text-transform: none;
    }
}

.collapse-btn {
  width: 25px;
  height: 25px;
  background: transparent;
  border: none;
  color: #FFFFFF;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: all 0.2s ease;
  
  &:hover {
    opacity: 0.8;
  }
  
  .collapse-icon {
    font-size: 24px;
    font-weight: 300;
    line-height: 1;
  }
}

// Container
.imprint-container {
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;  // Changed from flex-end to align left
  gap: 0;
}

// Delete Section
.delete-section {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;  // Align delete button to the left
  gap: 30px;
  margin-top: 10px;
}

.delete-btn {
  background: transparent;
  border: none;
  font-family: $font-family-base;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  color: $color-danger;
  cursor: pointer;
  padding: 0;
  
  &:hover {
    text-decoration: underline;
  }
}
</style>
